import { createFileRoute } from "@tanstack/react-router";
import SaintEs from "@/pages/es/SaintEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_SAINT_GOOGLE_URL = `${SITE_URL}/es/saint-google`;

export const Route = createFileRoute("/es/saint-google")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      {
        title: "SAINT® TMS para la depresión | Coral Springs, FL",
      },
      {
        name: "description",
        content:
          "SAINT® TMS de 5 días, guiada por fMRI, para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL, atendiendo a Florida y.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS para la depresión | Coral Springs, FL",
      },
      {
        property: "og:description",
        content:
          "SAINT® TMS de 5 días, guiada por fMRI, para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_SAINT_GOOGLE_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "SAINT® TMS para la depresión | Coral Springs, FL",
      },
      {
        name: "twitter:description",
        content:
          "SAINT® TMS de 5 días, guiada por fMRI, para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_SAINT_GOOGLE_URL },
      ...buildHreflang("/saint-google"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintEs google />;
}
